// Module
var code = "<education-sub-nav value=\"vm.config\" pagetype=\"practiceManagement_l1\"></education-sub-nav>";
// Exports
module.exports = code;